export interface Award {
  color: number; // Color
  title: string; // The title of the award
  link: string; // Link to the award's details (image, page, etc.)
  awarder: string; // The name of the organization that gave the award
  awarderLink: string; // Link to the awarder's website
  description: string; // Description of the award
  logo: string;      // Image for experience
}

// The list of the awards used in the Awards section
export const awardList: Award[] = [
  {
    color: 0,
    title: `Software Engineer Intern`,
    link: `https://www.rbccm.com/en/`,
    awarder: `RBC Capital Markets`,
    awarderLink: ``,
    description: `Incoming QTS Dev Fall 2026`,
    logo: '/assets/rbc-logo.png',   
  },
  {
    color: 1,
    title: `Software Engineer Intern`,
    link: `https://waccglobal.org/`,
    awarder: `WACC Global`,
    awarderLink: ``,
    description: `Built a full-stack internal platform replacing fragmented Excel,
QuickBooks, and SharePoint/MS365 spreadsheets, shipping 22 API route handlers and 16 dashboard pages across
24 React components for 30–65 CAP partner organizations`,
    logo: '/assets/WACCbg.png',   
  }
  ,
  {
    color: 2,
    title: `Software Engineer Intern`,
    link: `https://waccglobal.org/`,
    awarder: `Riipen Level UP`,
    awarderLink: ``,
    description: `Worked on AI-Powered Educational Platform for EduTutor, completely overhauling the existing platform to improve user experience and performance, implementing new features such as AI-powered tutoring and personalized learning paths, and optimizing the platform for scalability and maintainability.`,
    logo: '/assets/riipen-logo.png',   
  }
];
